/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PedestrianDeviceUpdate
 */
export interface PedestrianDeviceUpdate {
    /**
     * 
     * @type {string}
     * @memberof PedestrianDeviceUpdate
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PedestrianDeviceUpdate
     */
    hardwareSerialNumber?: string | null;
}

/**
 * Check if a given object implements the PedestrianDeviceUpdate interface.
 */
export function instanceOfPedestrianDeviceUpdate(value: object): value is PedestrianDeviceUpdate {
    return true;
}

export function PedestrianDeviceUpdateFromJSON(json: any): PedestrianDeviceUpdate {
    return PedestrianDeviceUpdateFromJSONTyped(json, false);
}

export function PedestrianDeviceUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PedestrianDeviceUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'hardwareSerialNumber': json['hardwareSerialNumber'] == null ? undefined : json['hardwareSerialNumber'],
    };
}

export function PedestrianDeviceUpdateToJSON(json: any): PedestrianDeviceUpdate {
    return PedestrianDeviceUpdateToJSONTyped(json, false);
}

export function PedestrianDeviceUpdateToJSONTyped(value?: PedestrianDeviceUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'hardwareSerialNumber': value['hardwareSerialNumber'],
    };
}

